import { humanErrorText } from '../helpers/errorText';

// Ð¡ÑÐ°ÑÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ: Ð±ÑÐºÐµÐ½Ð´ Ð¾ÑÐ´Ð°ÑÑ ÑÑÑÐ¾ÐºÑ Â«Ð¢Ð¸Ð¿: ÑÐµÐºÑÑ\nStackâ¦Â», Ð±ÐµÑÑÐ¼ ÑÐµÐºÑÑ
// Ð¼ÐµÐ¶Ð´Ñ Ð¿ÐµÑÐ²ÑÐ¼ Ð´Ð²Ð¾ÐµÑÐ¾ÑÐ¸ÐµÐ¼ Ð¸ Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð¾Ð¼ ÑÑÑÐ¾ÐºÐ¸.
const fromString = (text) => {
  const message = text.match(/:(.*)\n/);
  return message && message?.length ? message[1].trim() : null;
};

/**
 * Ð¢ÐµÐºÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸ Ð´Ð»Ñ ÑÐ¾ÑÑÐ° Ð¸Ð»Ð¸ null â ÑÐ¾Ð³Ð´Ð° Ð²ÑÐ·ÑÐ²Ð°ÑÑÐ¸Ð¹ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÑÐ²Ð¾Ð¹ Ð·Ð°Ð¿Ð°ÑÐ½Ð¾Ð¹
 * ÑÐµÐºÑÑ (`extractErrorMessage(err) || 'â¦'`).
 *
 * api.onError Ð¾ÑÐºÐ»Ð¾Ð½ÑÐµÑ Ð¿ÑÐ¾Ð¼Ð¸Ñ Ð¾Ð±ÑÐµÐºÑÐ¾Ð¼ Ð¾ÑÐ¸Ð±ÐºÐ¸ axios, Ð° Ð½Ðµ ÑÑÑÐ¾ÐºÐ¾Ð¹, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
 * ÑÑÐ´Ð° Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ñ ÑÑÐ¾ ÑÐ³Ð¾Ð´Ð½Ð¾: ÑÑÑÐ¾ÐºÐ° Ð¾ÑÐ²ÐµÑÐ°, response.data Ð¾Ð±ÑÐµÐºÑÐ¾Ð¼, ÑÐ°Ð¼Ð° Ð¾ÑÐ¸Ð±ÐºÐ°
 * axios Ð¸Ð»Ð¸ Ð¾Ð±ÑÑÐ½ÑÐ¹ Error. ÐÑÐ¾ÑÐ°ÑÑ Ð·Ð´ÐµÑÑ Ð½ÐµÐ»ÑÐ·Ñ: ÑÐ¿Ð°Ð²ÑÐ¸Ð¹ `.catch` Ð¾ÑÑÐ°Ð²Ð»ÑÐµÑ
 * Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ° Ð²Ð¾Ð¾Ð±ÑÐµ Ð±ÐµÐ· ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ñ.
 */
const extractErrorMessage = (error) => {
  if (!error) return null;
  if (typeof error === 'string') return fromString(error);
  if (typeof error !== 'object') return null;

  // ÐÑÐ¸Ð±ÐºÐ° axios Ð½ÐµÑÑÑ Ð¾ÑÐ²ÐµÑ Ð±ÑÐºÐµÐ½Ð´Ð° Ð² response.data; ÐµÑÐ»Ð¸ response Ð½ÐµÑ â
  // ÑÑÐ¾ Ð»Ð¸Ð±Ð¾ ÑÐ¶Ðµ ÑÐ°Ð¼ response.data, Ð»Ð¸Ð±Ð¾ Error (ÑÐµÑÑ, ÑÐ°Ð¹Ð¼Ð°ÑÑ, ÐºÐ¾Ð´).
  const payload = error.response ? error.response.data : error;
  // Ð¢Ð¾Ñ Ð¶Ðµ ÑÐ°Ð·Ð±Ð¾Ñ, ÑÑÐ¾ Ð¸ Ñ ÑÐ¾ÑÑÐ° Ð² api.onError: ÑÐµÐºÑÑÑ ÑÐ¾Ð²Ð¿Ð°Ð´Ð°ÑÑ, Ð¸
  // alert.error ÑÐºÐ»ÐµÐ¸Ð²Ð°ÐµÑ Ð¸Ñ Ð² Ð¾Ð´Ð½Ð¾ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ.
  return humanErrorText(payload);
};

export default extractErrorMessage;
